var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46183 6L0.293893 1.80269C0.0979644 1.60538 0 1.35426 0 1.04933C0 0.744395 0.0979644 0.493274 0.293893 0.295964C0.489822 0.0986547 0.739186 0 1.04198 0C1.34478 0 1.59415 0.0986547 1.79008 0.295964L6.70611 5.24664C6.81298 5.35426 6.88868 5.47085 6.93321 5.59641C6.97774 5.72197 7 5.8565 7 6C7 6.1435 6.97774 6.27803 6.93321 6.40359C6.88868 6.52915 6.81298 6.64574 6.70611 6.75336L1.79008 11.704C1.59415 11.9013 1.34478 12 1.04198 12C0.739186 12 0.489822 11.9013 0.293893 11.704C0.0979644 11.5067 0 11.2556 0 10.9507C0 10.6457 0.0979644 10.3946 0.293893 10.1973L4.46183 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/nextButton.b4c22b6b39ab8d96d42af04ca7fa3e5c.svg";
export { ForwardRef as ReactComponent };